import { init as FullStoryInit } from '@fullstory/browser';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import AppRouter from '@/Router';
import { store } from '@/store';
import { CssBaseline, GlobalCssPriority, theme, ThemeProvider } from '@/ui';

import { configureMomentsAnalytics } from '@/services/momentsAnalytics';
import { momentsApi } from '@/store/api/momentsApi';
import { initDatadogMonitoring } from '@/utils/datadogMonitoring';
import { captureException } from '@/utils/errorMonitoring';
import { reportStaleBundleRecovery } from '@/utils/staleBundleRecovery';

import './index.css';

initDatadogMonitoring();
reportStaleBundleRecovery();

if (import.meta.env.VITE_FULLSTORY_ORG) {
  try {
    FullStoryInit({ orgId: import.meta.env.VITE_FULLSTORY_ORG });
  } catch (e) {
    captureException(e);
  }
}

configureMomentsAnalytics((request) =>
  store.dispatch(
    momentsApi.endpoints.trackMomentsAnalyticsEvent.initiate(request, {
      track: false,
    }),
  ),
);

const rootElement = document.getElementById('main') as HTMLElement;

ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <GlobalCssPriority>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <CssBaseline />
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </LocalizationProvider>
        </ThemeProvider>
      </GlobalCssPriority>
    </ReduxProvider>
  </StrictMode>,
);
